export enum GameErrorType {
	SETTLEMENT_ERROR = "SETTLEMENT_ERROR",
	RESOURCE_ERROR = "RESOURCE_ERROR",
	SIEGE_SYSTEM_ERROR = "SIEGE_SYSTEM_ERROR",
	ROAD_ERROR = "ROAD_ERROR",
	DATA_ERROR = "DATA_ERROR",
	FE_ERROR = "FE_ERROR",
	BE_ERROR = "BE_ERROR",
	BE_TIMEOUT_ERROR = "BE_TIMEOUT_ERROR",
	BE_VALIDATION_ERROR = "BE_VALIDATION_ERROR",
	INTERNAL_UNKNOWN_ERROR = "INTERNAL_UNKNOWN_ERROR",
	PARALLEL_SESSION_ERROR = "PARALLEL_SESSION_ERROR",
	NETWORK_DISCONNECT_DURING_REQUEST = "NETWORK_DISCONNECT_DURING_REQUEST",
}

class GameError extends Error {
	public type: GameErrorType;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public data: Record<string, any> | null = null;

	public constructor(
		type: GameErrorType,
		message: string,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		data: Record<string, any> | null = null,
	) {
		super(message);
		this.type = type;
		this.data = data;
	}
}

export default GameError;
